export const QUICK_FILTER_VERSION = 1;
export const QUICK_FILTER_SOURCE = {
  SYSTEM: "SYSTEM",
  USER: "USER",
};
export const MAX_USER_QUICK_FILTERS_PER_PAGE = 6;

export const QUICK_FILTER_PAGE_IDS = {
  PRODUCT_ANALYTICS: "product_analytics",
  PERFORMANCE_ANALYSIS: "performance_analysis",
  CAMPAIGN_LIST_V2: "campaign_list_v2",
  TARGETING_V2: "targeting_v2",
  BID_ADJUST_V2: "bid_adjust_v2",
  SEARCH_TERM_V2: "search_term_v2",
};

export const QUICK_FILTER_KEY_MAPPER = {
  amazon: "amz_quick_filters",
  flipkart: "fk_quick_filters",
  myntra: "myn_quick_filters",
};

export const getQuickFilterKey = (platform = "amazon") => {
  const normalized = `${platform}`.toLowerCase();
  return (
    QUICK_FILTER_KEY_MAPPER[normalized] ?? QUICK_FILTER_KEY_MAPPER.amazon
  );
};

export const emptyQuickFilterValue = (platform = "amazon") => ({
  platform,
  version: QUICK_FILTER_VERSION,
  pages: {},
});

export const emptyPageQuickFilters = () => ({
  filters: [],
});

export const createEmptyFilterModuleFilters = () => ({
  metrics: { custom_output: [] },
  dimension: { custom_output: [] },
  campaigns: { custom_output: [] },
  topX: { custom_output: [] },
});

export const hasQuickFilterRules = (filterModuleFilters = {}) => {
  const sections = ["metrics", "dimension", "campaigns", "topX"];
  return sections.some((section) => {
    const customOutput = filterModuleFilters?.[section]?.custom_output;
    if (!customOutput || Array.isArray(customOutput)) return false;
    if (Array.isArray(customOutput?.and) && customOutput.and.length > 0) {
      return true;
    }
    if (Array.isArray(customOutput?.or) && customOutput.or.length > 0) {
      return true;
    }
    return false;
  });
};

export const createQuickFilterId = () =>
  `qf_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export const normalizeQuickFilter = (filter = {}) => {
  if (!filter || typeof filter !== "object") return null;
  const id = filter.id || createQuickFilterId();
  const name = `${filter.name || ""}`.trim();
  if (!name) return null;

  return {
    id,
    name,
    description: filter.description || "",
    source: filter.source === QUICK_FILTER_SOURCE.SYSTEM
      ? QUICK_FILTER_SOURCE.SYSTEM
      : QUICK_FILTER_SOURCE.USER,
    filterModuleFilters:
      filter.filterModuleFilters && typeof filter.filterModuleFilters === "object"
        ? filter.filterModuleFilters
        : createEmptyFilterModuleFilters(),
    createdAt: filter.createdAt || new Date().toISOString(),
    updatedAt: filter.updatedAt || filter.createdAt || new Date().toISOString(),
  };
};

export const normalizePageQuickFilters = (pageConfig = null) => {
  const filters = Array.isArray(pageConfig?.filters)
    ? pageConfig.filters.map(normalizeQuickFilter).filter(Boolean)
    : [];

  return { filters };
};

export const getPageQuickFilters = (configValue, pageId) => {
  const pageConfig = configValue?.pages?.[pageId] ?? null;
  return normalizePageQuickFilters(pageConfig);
};

export const buildMetricAndFilters = (ruleItems = []) => ({
  ...createEmptyFilterModuleFilters(),
  metrics: {
    custom_output: {
      type: "AND_RULE",
      and: ruleItems,
    },
  },
});

export const buildDimensionAndFilters = (ruleItems = []) => ({
  ...createEmptyFilterModuleFilters(),
  dimension: {
    custom_output: {
      type: "AND_RULE",
      and: ruleItems,
    },
  },
});

export const metricRuleItem = (member, operator, values) => ({
  type: "RULE_ITEM",
  member,
  operator,
  values: Array.isArray(values) ? values : [values],
});

/** Alias for dimension/campaign RULE_ITEM construction. */
export const dimensionRuleItem = metricRuleItem;
